import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/_services';
import { ApplicationTypes } from 'src/app/sharedcomp/constans/application-type.constans';
import { CustomDesignOptions } from 'src/app/sharedcomp/constans/customDesign.constans';
import { DesignVersionEnum } from 'src/app/_enums/design-version.enum';

@Component({
  selector: 'app-perfil-controller',
  template: `
    <div class="loading-wrapper">
      <div class="loading"></div>
    </div>
    <div class="app-container" appCustomV2DesignLayout>
    <app-snav-menu-controller class="app-side fixed" id="app-side"></app-snav-menu-controller>
     <!-- BEGIN .app-main -->
      <div class="app-main">

        <ng-container *ngIf="designVersion === 'V1'">
          <app-old-profile></app-old-profile>
        </ng-container>

      </div>
      <!-- END: .app-main -->
    </div>
  `,
})
export class ProfileController implements OnInit, OnDestroy {

  customerPuplic_key: string;
  importationConfiguration$: Subscription;
  designVersion: 'V1' | 'V2' | null = null;
  private destroy$ = new Subject<void>();
  private application: string;

  constructor(
    private router: Router,
    private spinnerService: Ng4LoadingSpinnerService,
    private configurationService: ConfigurationService
  ) {
    this.application = localStorage.getItem('application');
   }

  ngOnInit() {
    this.spinnerService.show();
    this.checkCredentials();
    this.getCustomerDesignConfiguration();
  }

  checkCredentials() {
    if (
      (localStorage.getItem('companyId') != null || localStorage.getItem('companyId') !== '') && (localStorage.getItem('application') != null || localStorage.getItem('application') !== '')) {
      if (localStorage.getItem('isCorporate') === 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
    } else {
      this.router.navigate(['/home']);
    }
  }

  getCustomerDesignConfiguration() {
    const urlConfig: (typeof CustomDesignOptions)[keyof typeof CustomDesignOptions] = CustomDesignOptions.CUSTOMER;
    this.importationConfiguration$ = this.configurationService.getCustomDesignConfiguration(this.customerPuplic_key, urlConfig)
    .pipe(
      takeUntil(this.destroy$)
    )
    .subscribe(data => {
      const configurationData = data;
      if (configurationData && configurationData.values.version && (this.application === ApplicationTypes.CORPORATE || this.application === ApplicationTypes.PAYMENTS)) {
        const pyoImportacionValue = configurationData.values.version;
        if ((pyoImportacionValue != null && pyoImportacionValue.trim().length > 0) && (pyoImportacionValue === "V1" || pyoImportacionValue === "V2")) {
          this.designVersion = DesignVersionEnum.designVersionDefault;
        } else {
          this.designVersion = DesignVersionEnum.designVersionDefault;
        }
      } else {
        this.designVersion = DesignVersionEnum.designVersionDefault;
      }
      this.spinnerService.hide();
    }, error => {
      this.designVersion = DesignVersionEnum.designVersionDefault;
      console.error('Failed! while trying to get customer design configuration. ' + error);
      this.spinnerService.hide();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
